import b from 'b_';
import { TriangleRounded } from 'education-icons';
import React from 'react';

import './skill-stats__progress-arrow.scss';

interface Props {
    isSuccess: boolean;
}

export const ProgressArrow = (props: Props) => {
    const { isSuccess } = props;

    return <TriangleRounded className={b('skill-stats', 'progress-arrow', { danger: !isSuccess })} />;
};
